import { Skeleton, Stack } from "@mui/material";
import { isEmpty } from "lodash";

import { useCase } from "../ExperimentalHomeHealth/Cases/api/useCase";
import { useVisit } from "../ExperimentalHomeHealth/Cases/api/useVisit";
import { APP_V2_APP_EVENTS, logError } from "../lib/analytics";
import { ChatWidgetCard } from "./ChatWidgetCard";

interface VisitInviteRequestMessageProps {
  visitId: string | undefined;
}

export function VisitInviteRequestMessage(props: VisitInviteRequestMessageProps) {
  const { visitId } = props;

  const { data: visit, isLoading: isVisitLoading, isError: isVisitError } = useVisit(visitId);
  const { caseId, type: visitType, workerReq } = visit?.attributes ?? {};

  const {
    data: caseRecord,
    isLoading: isCaseLoading,
    isError: isCaseError,
  } = useCase(caseId ?? undefined);

  const patient = caseRecord?.attributes.patient;
  const patientName = patient?.attributes.externalPatientIdentifier;

  if (isVisitLoading || isCaseLoading) {
    return (
      <Stack alignItems="flex-end" className="sendbird-admin-message">
        <Skeleton variant="text" width="50%" height="1.5rem" />
      </Stack>
    );
  }

  if (isVisitError || isCaseError || isEmpty(visitId) || isEmpty(caseId)) {
    logError(APP_V2_APP_EVENTS.VISIT_INVITE_REQUEST_MESSAGE_RENDER_FAILURE, {
      error: new Error("Failed to load visit invite data"),
      metadata: { visitId, caseId, isVisitError, isCaseError },
    });
    return null;
  }

  return (
    <Stack alignItems="flex-end" className="sendbird-admin-message">
      <ChatWidgetCard
        statusChip={null}
        title={`${visitType} ${workerReq} visit invite sent for ${patientName}`}
        subtitle=""
        actions={null}
      />
    </Stack>
  );
}
